import { createSlice } from '@reduxjs/toolkit';

import { resetAll } from 'store/reset';

const initialState = {
  step                          : 'overview',
  secondaryStep                 : 'medical-information',
  hasCompletedOverview          : false,
  hasCompletedMedicalInfo       : false,
  hasCompletedContactInfo       : false,
  hasCompletedConsent           : false,
  // To be removed after API intgeration
  hasCompletedSecondaryOverview : false,
};

const overviewSlice = createSlice({
  name     : 'overview',
  initialState,
  reducers : {
    updateOverviewStep : (state, action) => {
      state.step = action.payload;
    },

    updateSecondaryOverviewStep : (state, action) => {
      state.secondaryStep = action.payload;
    },

    setHasCompletedOverview : (state, action) => {
      state.hasCompletedOverview = action.payload;
    },

    setHasCompletedMedicalInfo : (state, action) => {
      state.hasCompletedMedicalInfo = action.payload;
    },

    setHasCompletedContactInfo : (state, action) => {
      state.hasCompletedContactInfo = action.payload;
    },

    setHasCompletedConsent : (state, action) => {
      state.hasCompletedConsent = action.payload;
    },

    setHasCompletedSecondaryOverview : (state, action) => {
      state.hasCompletedSecondaryOverview = action.payload;
    },
  },
  extraReducers : (builder) =>
    builder.addCase(resetAll.type, () => initialState),
});

export const {
  updateOverviewStep,
  updateSecondaryOverviewStep,
  setHasCompletedOverview,
  setHasCompletedSecondaryOverview,
  setHasCompletedMedicalInfo,
  setHasCompletedContactInfo,
  setHasCompletedConsent,
} = overviewSlice.actions;

export default overviewSlice;
